











































































































































































import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { IDomain } from "@/models/domains";
import { IDomainsProviderMethods } from "@/models/providers/domains";

@Component
export default class DomainsGridItem extends Vue {
  // Inject

  @Inject({ from: "domainsProviderMethods" })
  public $domainsMethods!: IDomainsProviderMethods;

  // Props

  @Prop({ default: undefined })
  public domain!: IDomain;

  @Prop({ default: false })
  public isLoading!: boolean;

  // Computed

  /**
   * @name isPointable
   * @desc A domain is only considered pointable if it's been enabled for either
   * client or admin logins. Otherwise its inclusion should be predominantly for
   * trust reasons – such as widget inclusion.
   */

  public get isPointable() {
    return this.domain.staff_enabled || this.domain.customer_enabled;
  }

  public get isUnverified() {
    if (!this.isPointable) return false;
    return !this.domain.verified;
  }

  public get canManageDomain() {
    return this.$userCan("get_oauth_client");
  }

  public get canVerifyDomain() {
    return (
      this.$userCan("verify_oauth_client") &&
      this.isPointable &&
      !this.domain.verified
    );
  }

  public get canMakeDomainDefault() {
    return (
      this.$userCan("update_oauth_client") &&
      this.domain.verified &&
      !this.domain.default &&
      this.domain.origin_healthy
    );
  }

  public get canRevokeDomain() {
    return (
      this.$userCan("update_oauth_client") &&
      !this.domain.default &&
      !this.domain.revoked
    );
  }

  public get canUnrevokeDomain() {
    return (
      this.$userCan("update_oauth_client") &&
      !this.domain.default &&
      this.domain.revoked
    );
  }

  public get canDeleteDomain() {
    return (
      this.$userCan("delete_oauth_client") &&
      !this.domain.default &&
      this.domain.custom
    );
  }
}
